import { useEffect, useRef } from "react";

export default function useVisibilityPolling(callback, intervalMs, options = {}) {
  const { enabled = true, runImmediately = true } = options;
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) return undefined;

    let intervalId = null;

    const stop = () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const tick = () => callbackRef.current?.();

    const start = () => {
      if (document.visibilityState !== "visible" || intervalId) return;
      intervalId = setInterval(tick, intervalMs);
    };

    if (runImmediately && document.visibilityState === "visible") tick();
    start();

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        if (runImmediately) tick();
        start();
      } else {
        stop();
      }
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [enabled, intervalMs, runImmediately]);
}
